import * as React from 'react';
import styled from 'styled-components'

interface IProps
    extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
}

const SubmitErrorTextWrapperDefault: React.SFC<IProps> = (props) => {

    const { ...DivProps } = props;

    return (<div {...DivProps} />)

};

const SubmitErrorTextWrapper = styled(SubmitErrorTextWrapperDefault)`
    text-align: center;
    
`;

export default SubmitErrorTextWrapper;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/wrapper/submit_error_text_wrapper.tsx